import type { FlowExecutionType } from "@/types/entities/flows";
import { formatDateTime } from "@/utils/dates";
import { Badge, Icon } from "@elaniintc/goes-design-system";
import { getExecutionBadge } from ".";

interface Props {
  execution: FlowExecutionType["node_executions"][number];
}

const AssignGroupContent = ({ execution }: Props) => {
  const userName = execution.outputs?.find(
    (output) => output.name === "user_name",
  )?.value as string;

  const userId = execution.outputs?.find((output) => output.name === "user_id")
    ?.value as string;

  const groupId = execution.outputs?.find(
    (output) => output.name === "group_id",
  )?.value as string;

  const priority = execution.outputs?.find(
    (output) => output.name === "priority",
  )?.value as number;

  const assignableLevels = execution.inputs
    ?.filter((input) => input.name === "assignable_levels")
    .map((input) => input.value as string);

  return (
    <div className="w-full flex flex-col gap-4">
      <div className="flex flex-col gap-2">
        <p>Estado del nodo: {getExecutionBadge(execution.status)}</p>
      </div>

      <div className="border border-neutral rounded-lg p-4 flex flex-col gap-3">
        <div className="flex items-center gap-3">
          <Icon
            type="far"
            name="user"
            className="text-contextual-action text-xl"
          />
          <div className="flex flex-col">
            <span className="font-semibold text-body-loud">
              {userName || "Usuario no disponible"}
            </span>
            <span className="text-sm text-body-quiet">
              Asignado: {formatDateTime(execution.started_at)}
            </span>
          </div>
        </div>

        {priority !== undefined && (
          <div className="flex items-center gap-2 text-sm">
            <span className="text-body-quiet">Prioridad:</span>
            <Badge
              variant={
                priority === 1 ? "warning" : priority === 2 ? "info" : "neutral"
              }
              size="sm"
            >
              Nivel {priority}
            </Badge>
          </div>
        )}

        {assignableLevels && assignableLevels.length > 0 && (
          <div className="flex flex-col gap-1 text-sm border-t border-neutral pt-3 mt-1">
            <span className="text-body-quiet font-semibold mb-1">
              Niveles asignables:
            </span>
            <div className="flex gap-2">
              {assignableLevels.map((level, index) => (
                <Badge key={index} variant="neutral" size="sm">
                  Nivel {level}
                </Badge>
              ))}
            </div>
          </div>
        )}

        <div className="flex flex-col gap-2 text-sm border-t border-neutral pt-3 mt-1">
          {userId && (
            <div className="flex items-center gap-2">
              <span className="text-body-quiet">ID del usuario:</span>
              <span className="text-body font-mono text-xs">{userId}</span>
            </div>
          )}
          {groupId && (
            <div className="flex items-center gap-2">
              <span className="text-body-quiet">ID del grupo:</span>
              <span className="text-body font-mono text-xs">{groupId}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AssignGroupContent;
